import {Mapper} from '@s-ui/domain'

export class SeoPublishYourAdMetaInformationMapper extends Mapper {
  constructor({config, structuredDataMapper, seoDataValueObjectFactory, seoDataMapper, seoLiteralMapper}) {
    super()

    this._config = config
    this._structuredDataMapper = structuredDataMapper
    this._seoDataValueObjectFactory = seoDataValueObjectFactory
    this._seoDataMapper = seoDataMapper
    this._seoLiteralMapper = seoLiteralMapper
  }

  _buildCanonical = ({location}) => {
    const protocol = this._config.get('URL_PROTOCOL')
    const host = this._config.get('HOST_DOMAIN')
    const {PUBLISH_YOUR_VEHICLE_PATH_PATTERN} = this._config.get('page')

    if (!location) return `${protocol}${host}${PUBLISH_YOUR_VEHICLE_PATH_PATTERN}`

    const {SEMANTIC_SELLER_LOCATIONS_MAPPING} = this._config.get('seller')
    const sellerLocation = Object.values(SEMANTIC_SELLER_LOCATIONS_MAPPING).find(({label}) => label === location)
    const locationSuffix = sellerLocation ? `/${sellerLocation.slug}` : ''
    return `${protocol}${host}${PUBLISH_YOUR_VEHICLE_PATH_PATTERN}${locationSuffix}`
  }

  async map({culture, params: {location} = {}}) {
    const {publishYourAd: publishYourAdConfig, publishYourAdWithLocation: publishYourAdWithLocationConfig} =
      this._config.get('seo')

    const seoConfig = location ? publishYourAdWithLocationConfig : publishYourAdConfig

    const placeholderValues = {location}

    const {H1, TITLE, META_DESCRIPTION, META_ROBOTS} = seoConfig[culture]

    const canonical = this._buildCanonical({location})

    const parsedTitle = this._seoLiteralMapper.setText({text: TITLE}).setPlaceholderValues({placeholderValues}).map()

    const parsedDescription = this._seoLiteralMapper
      .setText({text: META_DESCRIPTION})
      .setPlaceholderValues({placeholderValues})
      .map()

    const parsedH1 = this._seoLiteralMapper.setText({text: H1}).setPlaceholderValues({placeholderValues}).map()

    const structuredDataVO = this._structuredDataMapper.map({location})

    const {links, metas, scripts, title} = this._seoDataMapper
      .title(parsedTitle)
      .description(parsedDescription)
      .robots(META_ROBOTS)
      .canonical(canonical)
      .addSchemaData(structuredDataVO)
      .setOpenGraphData({
        title: parsedTitle,
        description: parsedDescription,
        url: canonical
      })
      .setTwitterCardsData()
      .map()

    return this._seoDataValueObjectFactory({
      h1: parsedH1,
      head: {
        link: links,
        meta: metas,
        scripts,
        title
      }
    })
  }
}
